import { render, staticRenderFns } from "./ExportDataForm.vue?vue&type=template&id=02241472&scoped=true"
import script from "./ExportDataForm.vue?vue&type=script&lang=js"
export * from "./ExportDataForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02241472",
  null
  
)

export default component.exports